import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import { USER_STATUSES, USER_STATUSES_TEACHER } from '../../../../../constants/statuses';

const renderTextField = ({ input, meta: { touched, error }, i18n, statuses, ...custom }) => {

    return (
        <NativeSelect {...input} {...custom}>
            <option>{i18n.t('users.choose_status')}</option>
            {statuses.map((item, key) => {
                return (
                    <option key={key} value={item.id}>
                        {i18n.t('users.' + item.title)}
                    </option>
                );
            })}
        </NativeSelect>
    );
};

export default ({ label, code, type }) => {
    const { i18n } = useTranslation();
    const user = useSelector(state => state.user);
    const role_id = user.emulation.length
        ? user.emulation[user.emulation.length - 1].info.role_id
        : user.info.role_id;
    const statuses = role_id === 3 && type === 'status_select_teacher' ? USER_STATUSES_TEACHER : USER_STATUSES;
    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                    {i18n.t(label)}
                </Typography>
                <Field name={code} statuses={statuses} i18n={i18n} component={renderTextField} type="text" />
            </CardContent>
        </Card>
    );
};
